// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var ReactRelay = require("react-relay");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

function makeRefetchVariables() {
  
}

var Types = {
  makeRefetchVariables: makeRefetchVariables
};

function unwrap_response_sessionV5_authenticatedUserV2_value(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["Agent"]);
}

var variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"sessionV5_authenticatedUserV2_value_Agent":{"f":""},"sessionV5_authenticatedUserV2_value":{"u":"response_sessionV5_authenticatedUserV2_value"}}};

var wrapResponseConverterMap = {
  response_sessionV5_authenticatedUserV2_value: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"sessionV5_authenticatedUserV2_value_Agent":{"f":""},"sessionV5_authenticatedUserV2_value":{"u":"response_sessionV5_authenticatedUserV2_value"}}};

var responseConverterMap = {
  response_sessionV5_authenticatedUserV2_value: unwrap_response_sessionV5_authenticatedUserV2_value
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserSessionChapterInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SessionV5",
        "kind": "LinkedField",
        "name": "sessionV5",
        "plural": false,
        "selections": [
          {
            "kind": "CatchField",
            "field": {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "authenticatedUserV2",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "UserSessionChapterInfo_chapterInfo"
                    }
                  ],
                  "type": "Agent",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            "to": "RESULT"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserSessionChapterInfoQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SessionV5",
        "kind": "LinkedField",
        "name": "sessionV5",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "authenticatedUserV2",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChapterV5",
                    "kind": "LinkedField",
                    "name": "defaultChapter",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "id",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "databaseId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "Agent",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v1/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dff27722fd32bd55a4bbf4cf155f7c7f",
    "id": null,
    "metadata": {},
    "name": "UserSessionChapterInfoQuery",
    "operationKind": "query",
    "text": "query UserSessionChapterInfoQuery {\n  sessionV5 {\n    authenticatedUserV2 {\n      __typename\n      ... on Agent {\n        ...UserSessionChapterInfo_chapterInfo\n      }\n      ... on Node {\n        __isNode: __typename\n        __typename\n        nodeId\n      }\n    }\n  }\n}\n\nfragment UserSessionChapterInfo_chapterInfo on Agent {\n  defaultChapter {\n    id: databaseId\n    displayName\n    nodeId\n  }\n}\n"
  }
};
})());

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
              fetchKey: fetchKey,
              fetchPolicy: fetchPolicy,
              networkCacheConfig: networkCacheConfig
            });
}

function queryRefToObservable(token) {
  return Caml_option.nullable_to_opt(token.source);
}

function queryRefToPromise(token) {
  return new Promise((function (resolve, param) {
                var o = queryRefToObservable(token);
                if (o !== undefined) {
                  Caml_option.valFromOption(o).subscribe({
                        complete: (function () {
                            resolve({
                                  TAG: "Ok",
                                  _0: undefined
                                });
                          })
                      });
                  return ;
                } else {
                  return resolve({
                              TAG: "Error",
                              _0: undefined
                            });
                }
              }));
}

var wrap_response_sessionV5_authenticatedUserV2_value = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_sessionV5_authenticatedUserV2_value = unwrap_response_sessionV5_authenticatedUserV2_value;
exports.wrap_response_sessionV5_authenticatedUserV2_value = wrap_response_sessionV5_authenticatedUserV2_value;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
